import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ReactGA from 'react-ga';

function DisplayTab({ onChange, teams, value }) {
  function handleClick(event, newValue) {
    if (newValue !== value) {
      ReactGA.event({
        category: 'Boxscore Display Tab',
        action: 'Switched Boxscore Display Tab',
        label: `New Display: ${value}`,
      });

      onChange(newValue)
    }
  }

  return (
    <Tabs centered value={value} onChange={handleClick} aria-label="Team Boxscore Display Tab">
      <Tab label={teams[teams.visitor].name} value="visitor" />
      <Tab label={teams[teams.home].name} value="home" />
    </Tabs>
  )
}

export default DisplayTab;
